export default {
  schema: {
    type: "number",
  },
  uiSchema: {
    "ui:widget": "updown",
  },
};
